/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner
 */
export interface AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner
     */
    name: string;
}

/**
 * Check if a given object implements the AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner interface.
 */
export function instanceOfAssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner(value: object): value is AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerFromJSON(json: any): AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner {
    return AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerFromJSONTyped(json, false);
}

export function AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerToJSON(json: any): AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner {
    return AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerToJSONTyped(json, false);
}

export function AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInnerToJSONTyped(value?: AssetControllerGetAssetModelsMetadataByAssetTypeId200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

